import { isNil, none, prop, propOr, sum } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';
import { fromIsoDate } from 'utils';
import { equalOrZero } from 'utils/equalOrThreeDashes';

import { NAME, transitionRowWithDefaultValues } from './constants';

const getRoot = prop(NAME);

export const getSemaphoreRecords = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'semaphoreRecords'));
export const getRecordsFeedback = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'recordsFeedback'));

export const getFeedbackByRecordId = createSelector(
	getRecordsFeedback,
	(state, partnerId) => partnerId,
	(recordsFeedback, partnerId) => {
		return propOr(null, partnerId)(recordsFeedback);
	},
);

export const getSemaphoreInfoGraphics = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'semaphoreInfoGraphics'));
export const getGraphLastActualizationDate = createSelector(getSemaphoreInfoGraphics, (infoGraphicsData) => {
	const lastActualizationDate = propOr(EMPTY_VALUES.STRING, 'lastActualizationDate')(infoGraphicsData);
	return fromIsoDate(lastActualizationDate);
});
export const getSemaphoreClientsTotal = createSelector(getSemaphoreInfoGraphics, propOr(EMPTY_VALUES.OBJECT, 'total'));
export const getSemaphoreTransitionCountsByStateIds = createSelector(
	getSemaphoreInfoGraphics,
	(state, fromState) => fromState,
	(state, fromState, toState) => toState,
	(infoGraphicsData, fromState, toState) => {
		const { firstMonth, secondMonth, thirdMonth } = infoGraphicsData;
		const hasMonths = none(isNil, [firstMonth, secondMonth, thirdMonth]);

		if (hasMonths) {
			const allStatesArr = [...firstMonth?.states, ...secondMonth?.states, ...thirdMonth?.states];

			const chosenFromToStates = allStatesArr.filter(
				(item) => item.stateId === fromState && item.futureStateId === toState,
			);
			return chosenFromToStates.map((item) => item?.count);
		} else {
			return transitionRowWithDefaultValues;
		}
	},
);

export const getSemaphoreClientsAllMonthsSumByStateIds = createSelector(getSemaphoreTransitionCountsByStateIds, sum);

export const getSemaphoreAllMonthsTotalSum = createSelector(getSemaphoreInfoGraphics, (infoGraphicsData) => {
	const { firstMonth, secondMonth, thirdMonth } = infoGraphicsData;
	const sumArray = [firstMonth?.sum, secondMonth?.sum, thirdMonth?.sum];
	return sum(sumArray.map((item) => equalOrZero(item)));
});
